import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'ATR',
  version: 1,
  label: 'Average True Range',
  pane: 'sub',
  category: 'volatility',
  series: 'price',
  order: 10,
  // TA-Lib allows a period of 1 (then ATR is the true range itself).
  inputs: [period('timeperiod', 14, 'Length', 1)],
  outputs: [line('atr', 'ATR', COLOR.red)],
  talib: { functions: ['ATR'], expr: 'ATR(high, low, close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
